import React, { createContext, useContext } from "react";

const DEFAULT_MAPPING_STATE = {
  loading: false,
  resolved: false,
  subjectId: null,
  clinicStudyId: null,
  error: null,
};

const UserClinicMappingContext = createContext(DEFAULT_MAPPING_STATE);

export function UserClinicMappingProvider({ value, children }) {
  return (
    <UserClinicMappingContext.Provider
      value={value ?? DEFAULT_MAPPING_STATE}
    >
      {children}
    </UserClinicMappingContext.Provider>
  );
}

export function useCurrentUserClinicMapping() {
  return useContext(UserClinicMappingContext);
}
